export default __webpack_public_path__ + "static/cp-blue-a94373629def49deb87b9827d102e39f.png";